var _path, _circle, _path2, _circle2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrderStatus2B(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 84 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83.2939 40C83.2939 45.2529 82.2593 50.4543 80.2491 55.3073C78.2389 60.1604 75.2926 64.5699 71.5782 68.2843C67.8639 71.9986 63.4543 74.945 58.6013 76.9552C53.7483 78.9654 48.5468 80 43.2939 80V40H83.2939Z",
    fill: "#F6AE2C"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 43.2939,
    cy: 40,
    r: 38,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M83.2939 40C83.2939 34.7471 82.2593 29.5457 80.2491 24.6927C78.2389 19.8396 75.2926 15.4301 71.5782 11.7157C67.8639 8.00138 63.4543 5.05501 58.6013 3.04482C53.7483 1.03463 48.5468 -2.2961e-07 43.2939 0V40H83.2939Z",
    fill: "#F6AE2C"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 43.2939,
    cy: 40,
    r: 38,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7521 48.625V34.9583H32.8354V48.625C32.8354 49.9842 33.3754 51.2878 34.3365 52.2489C35.2977 53.21 36.6012 53.75 37.9604 53.75H51.6271C52.9864 53.75 54.2899 53.21 55.251 52.2489C56.2122 51.2878 56.7521 49.9842 56.7521 48.625Z",
    stroke: "#474747",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2939 34.9583H58.4606",
    stroke: "#474747",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2524 24.7083V28.125",
    stroke: "#474747",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7939 23V28.125",
    stroke: "#474747",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3354 24.7083V28.125",
    stroke: "#474747",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderStatus2B);
export default __webpack_public_path__ + "static/media/orderStatus2b.d3a91d5c.svg";
export { ForwardRef as ReactComponent };